<template>
  <svg
    :class="['w-5 h-5 text-gray-500', className] | twMerge"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="2.5" y="14" width="2.75" height="7.5" rx="1" :fill="color" />
    <rect x="7" y="11" width="2.75" height="10.5" rx="1" :fill="color" />
    <path
      d="M3 10.5 8.5 5.5l3 2.5L18.5 2.5"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M14.75 2.5h3.75v3.75" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <circle cx="17" cy="16.5" r="5.5" :fill="color" />
    <path
      d="M18.6 14.6c-.3-.5-.9-.8-1.6-.8-.9 0-1.6.5-1.6 1.2 0 1.6 3.3.9 3.3 2.6 0 .7-.7 1.3-1.7 1.3-.7 0-1.4-.3-1.7-.9M17 13v1M17 19v1"
      stroke="white"
      stroke-width="1.2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChartMixedDollarFilled',
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
